import { jwtDecode } from 'jwt-decode'
import config from '../../config.json'
import http from './httpService'
// import { logOut } from './redirect'

export async function addFirebaseToken(firebaseToken) {
  let rToken = localStorage.getItem('refresh_token')
  if (rToken && firebaseToken) {
    await http.post(`${config.apiUrl}/Account/FirebaseToken`, {
      FirebaseToken: firebaseToken,
      RefreshToken: rToken,
    })
    saveToLocalStorage('listenerId', firebaseToken)
  }
}

export async function deleteFirebaseToken() {
  let rToken = localStorage.getItem('refresh_token')
  if (rToken) {
    await http.delete(`${config.apiUrl}/Account/FirebaseToken?refreshToken=` + rToken)
    localStorage.removeItem('listenerId')
  }
}

export async function logout(returnUrl) {
  let rToken = localStorage.getItem('refresh_token')
  if (rToken) {
    await http.get(`${config.apiUrl}/Account/Logout?refreshToken=` + rToken)
  }
  localStorage.clear()
  if (returnUrl) {
    localStorage.setItem('returnUrl', returnUrl)
  }
  window.location.replace('/')
}

export function getCurrentUserId() {
  let token = loadFromLocalStorage('access_token')
  if (!token) {
    return null
  }
  const user = jwtDecode(token)
  return user['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier']
}

export function getCurrentUserRole() {
  let token = loadFromLocalStorage('access_token')
  if (!token) {
    return null
  }
  const user = jwtDecode(token)
  return user['Role']
}

export const saveToLocalStorage = (name, value) => {
  setTimeout(() => {
    localStorage.setItem(name, value)
  }, 100)
}

export const loadFromLocalStorage = (name) => {
  return localStorage.getItem(name)
}
export async function loginUser(user) {
  let token = loadFromLocalStorage('access_token')
  if (token) {
    const tokenResult = jwtDecode(token)
    const firstUrl = tokenResult.AccessPages[0]

    return firstUrl ? '/Dashboard' : logout()
  } else if (!user) {
    return ''
  }

  let { data } = await http.post(`${config.apiUrl}/Account/CustomerPanel/Login`, user)

  if (data?.access_token) {
    const returnUrl = loadFromLocalStorage('returnUrl')

    localStorage.clear()
    saveToLocalStorage('access_token', data.access_token)
    saveToLocalStorage('refresh_token', data.refresh_token)

    if (data.listenerId) saveToLocalStorage('listenerId', data.listenerId)
    if (data.UserImage) saveToLocalStorage('user_image', data.UserImage)
    const tokenResult = jwtDecode(data.access_token)
    const firstUrl = tokenResult.AccessPages[0]
    return returnUrl ? returnUrl : firstUrl ? '/Dashboard' : logout()
  } else {
    localStorage.clear()
  }
  return undefined
}

export function getCurrentUserName() {
  let token = loadFromLocalStorage('access_token')
  if (!token) {
    return null
  }
  const user = jwtDecode(token)
  return user['Name']
}

export function getCurrentUserDisplayName() {
  let token = loadFromLocalStorage('access_token')
  if (!token) {
    return null
  }
  const user = jwtDecode(token)
  return user['DisplayName']
}
